import { object, string, ref, date } from 'yup'
import { isDate } from 'moment'
import { parse } from 'uuid'

export const RegisterValidation = object().shape({
	email: string().email('Invalid email address').required('Required'),
	fname: string()
		.matches(/^[a-zA-Z]+$/, 'Invalid characters in Forename')
		.required('Required'),
	lname: string()
		.matches(/^[a-zA-Z]+$/, 'Invalid characters in Surname')
		.required('Required'),
	biologicalSex: string().required('Required'),
	persona: string().required('Required'),
	dob: date()
		.transform(function (value, originalValue) {
			if (this.isType(value) || isDate(value)) {
				return value
			}

			const parsedDate = parse(originalValue)
			return isDate(parsedDate) ? parsedDate : new Date('')
		})
		.typeError("Please enter a valid date")
		.required("Required")
		.min(new Date(1969, 10, 13), "Date is too early")
		.test(
			'olderThan14',
			'Must be older than 14 years',
			function (value) {
				if (value) {
					const yearsDifference = new Date().getFullYear() - value.getFullYear()
					return yearsDifference >= 14
				}
				return false
			}
		),
	password: string()
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
			'Your password must be at least 8 characters, 1 uppercase, 1 lowercase & 1 number'
		)
		.required('Required'),
		confirmPwd: string()
		.oneOf([ref('password')], 'Passwords do not match')
		.required('Required')
})

export const LoginValidation = object().shape({
	email: string().email('Invalid email address').required('Required'),
	password: string().required('Required')
})

export const ResetPwdValidation = object().shape({
	email: string().email('Invalid email address').required('Required')
})

export const SetPwdValidation = object().shape({
	password: string()
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
			'Your password must be at least 8 characters, 1 uppercase, 1 lowercase & 1 number'
		)
		.required('Required'),
		confirmPwd: string()
		.oneOf([ref('password')], 'Passwords do not match')
		.required('Required')
})
